import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { optional } from '@nullvoxpopuli/ember-composable-helpers';
import UiButtonGroup from 'garaje/components/ui/button-group';
import UiButton from 'garaje/components/ui-button';

interface SettingsPanelBodyStatesSignature {
  Args: {
    editLabel?: string;
    isEditing: boolean;
    isOpen: boolean;
    isPreviewing: boolean;
    previewLabel?: string;
    toEditing: () => void;
    toPreviewing: () => void;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}
export default class SettingsPanelBodyStates extends Component<SettingsPanelBodyStatesSignature> {
  get editLabel(): string {
    return this.args.editLabel ?? 'Edit text';
  }

  get previewLabel(): string {
    return this.args.previewLabel ?? 'Preview';
  }

  <template>
    {{#if @isOpen}}
      <div class="row mb-4 mt-10 flex justify-center" ...attributes>
        <UiButtonGroup @segmented={{true}}>
          <UiButton
            class="w-36 btn btn--brandOutlineFill btn--small {{if @isEditing 'active'}}"
            {{on "click" (optional @toEditing)}}
            data-test-id="to-editing"
          >
            {{this.editLabel}}
          </UiButton>
          <UiButton
            class="w-36 btn btn--brandOutlineFill btn--small {{unless @isEditing 'active'}}"
            {{on "click" (optional @toPreviewing)}}
            data-test-id="to-previewing"
          >
            {{this.previewLabel}}
          </UiButton>
        </UiButtonGroup>
      </div>
      {{yield}}
    {{/if}}
  </template>
}
